var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('input',{staticClass:"form-control",attrs:{"type":_vm.inputType,"min":_vm.formattedMin},domProps:{"value":_vm.formattedValue},on:{"input":function($event){return _vm.onInput($event.target.value)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }